import React, { useState } from "react"
import { get, concat, reverse, chunk, toNumber } from "lodash"
import DatePicker from "react-datepicker"
import ClassName from "classnames"

import { tableColumns } from "config/table_columns"
import { BaseTable, SeparateTable } from "components/molecules/table"
import { APIResponse } from "redux/apis/types"
import { useChartRegs } from "components/actions/symbolDetail"
import { Labels } from "components/atoms/input/input"
import { PAGE_NUM, SECURITY_TYPE } from "config/const"
import { Pagination } from "components/molecules/pagination"
import { checkIsSp } from "utils/util"
import dayjs from "dayjs"
import { useSelector } from "react-redux"

type DataPropsType = {
  symbolDetail: APIResponse.Res
}

type ChartListDataType = {
  Columns: Array<number | string>
  LegList: Array<Array<number | string>>
}
type ChartListType = (chartData: APIResponse.Res) => ChartListDataType

const chartList: ChartListType = chartData => {
  if (!chartData) {
    return { Columns: [], LegList: [] }
  }
  const chart = get(chartData, "Chart")
  const symbol = get(chartData, "Symbol")
  const column: Array<number | string> = concat(
    get(chart, "Columns"),
    "NumberOfDecimals"
  )
  const legList: Array<Array<number | string>> = get(chart, "LegList", []).map(
    (li: Array<string | number>) => {
      return concat(li, get(symbol, "NumberOfDecimals"))
    }
  )
  return {
    Columns: column,
    LegList: reverse(legList),
  }
}

const changeDateString = (date: string, def: boolean) =>
  new Date(
    toNumber(date.slice(0, 4)) - (def ? 2 : 0),
    toNumber(date.slice(4, 6)) - 1,
    def ? 1 : toNumber(date.slice(6, 8))
  )

export const Data: React.FC<DataPropsType> = props => {
  const symbol = get(props.symbolDetail, "Symbol", null)
  const isRefresh = useSelector(
    (state: { symbolDetail: { refresh: boolean } }) =>
      state.symbolDetail.refresh
  )
  const isDisplay =
    get(symbol, "SecurityType", null) !== SECURITY_TYPE.US_Equity.id
  const lastCloseDate = get(symbol, "LastCloseTime")
  const [isLoad, setLoad] = useState<boolean>(false)
  const isSp = checkIsSp()
  const today = dayjs().format("YYYY/MM/DD")

  const minimumDate: Date = lastCloseDate
    ? changeDateString(lastCloseDate, true)
    : null

  const defaultCount = 20

  const [
    chartData,
    type,
    changeType,
    page,
    setPage,
    settingDate,
    setDate,
  ] = useChartRegs(
    get(props.symbolDetail, "Symbol", null),
    defaultCount,
    isLoad,
    isSp,
    () => setLoad(false),
    isRefresh
  )

  return (
    <div className="panel-division panel-symbol-detail-data">
      <div className="title-table-container">
        <div className="filter-control-item title-table-header">
          {isDisplay && !isSp ? (
            <Labels
              className="btn-segmented-control btn-thin liquid-control"
              labelList={[{ name: "日足", id: 0 }, { name: "歩み値", id: 1 }]}
              checked={type}
              onChange={(id: number) => changeType(id)}
            />
          ) : null}
          {!type ? (
            <div className="filter-control-item filter-control-term">
              <div className="label-filter-control">開始日付</div>
              <div className="text-field text-field-outlined">
                <DatePicker
                  className="text-field-input"
                  selected={settingDate}
                  onChange={date => setDate(date)}
                  placeholderText="日付を設定"
                  minDate={minimumDate}
                  dateFormat="yyyy/MM/dd"
                  showYearDropdown
                  maxDate={new Date(today)}
                />
              </div>
            </div>
          ) : null}
          {/*<div*/}
          {/*  className="header-icon ripple"*/}
          {/*  onClick={() => !isLoad && setLoad(true)}*/}
          {/*>*/}
          {/*  <i*/}
          {/*    className={ClassName("material-icons", { "is-loading": isLoad })}*/}
          {/*    title={"更新"}*/}
          {/*  >*/}
          {/*    sync*/}
          {/*  </i>*/}
          {/*</div>*/}
        </div>
        <div className="title-table-items">
          {type && isDisplay ? (
            <div>
              <SeparateTable
                list={tableColumns.symbolDetail.timeSale}
                data={chartList(chartData).LegList}
                className="table-list-view table-liquid-cell table-striped trade-price"
                scrollable={true}
              />
            </div>
          ) : (
            <div>
              <BaseTable
                list={tableColumns.symbolDetail.data}
                data={
                  chunk(chartList(chartData).LegList, PAGE_NUM.PAGE_20)[page]
                }
                className="table-striped table-border"
              />
              <Pagination
                list={chartList(chartData).LegList}
                current={page}
                page={PAGE_NUM.PAGE_20}
                changePage={(p: number) => setPage(p)}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
